module.exports = __webpack_public_path__ + "static/media/wobbling-particles.c67ceeba.svg";